import * as React from "react";
import { Link } from "gatsby";
import * as styles from "./nav.module.css";

const Nav = ({ style }) => (
  <nav className={styles.siteNav} style={style}>
    <Link
      to="/drawings"
      className={styles.siteNavItem}
      activeClassName={styles.active}
    >
      Drawings
    </Link>
    <Link
      to="/wall-paintings"
      className={styles.siteNavItem}
      activeClassName={styles.active}
    >
      Wall-Paintings
    </Link>
    <Link
      to="/editions"
      className={styles.siteNavItem}
      activeClassName={styles.active}
    >
      Editions
    </Link>
    <Link
      to="/music"
      className={styles.siteNavItem}
      activeClassName={styles.active}
    >
      Music
    </Link>
    <Link
      to="/cv"
      className={styles.siteNavItem}
      activeClassName={styles.active}
    >
      C.V.
    </Link>
    <Link
      to="/contact"
      className={styles.siteNavItem}
      activeClassName={styles.active}
    >
      Contact
    </Link>
  </nav>
);

export default Nav;
